<template>
    <!--<v-expansion-panels>
        <v-expansion-panel>
            <v-expansion-panel-header>Usuarios</v-expansion-panel-header>
            <v-expansion-panel-content>-->
                
                <v-data-table
                    :headers="headers"
                    :items="users"
                    sort-by="calories"
                    class="elevation-1"
                >
                <template v-slot:top>
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64" color="accent"> {{mensage}}</v-progress-circular>
                </v-overlay>
                <v-overlay :value="overlayCapacity">
                    <v-progress-circular indeterminate size="64" color="accent"></v-progress-circular>
                </v-overlay>
                <v-dialog v-model="dialog" max-width="1500px" height="1500px">
                    <ProposalFilter v-on:close-dialog="close"/>
                </v-dialog>
                <v-dialog v-model="dialogChart" max-width="900px" height="1500px">
                    <v-card height="100 %">
                        <apexchart type="line" height="350" width="95%" :options="chartOptions" :series="series"></apexchart>
                    </v-card>
                </v-dialog>
                <div style="position: absolute; z-index: 1; visibility: visible; right: 15px;">
                        <v-progress-circular :rotate="-90" :size="100" :width="15" :value="timevalue" :color="remainingPathColor">
                            {{ formattedTimeLeft }}
                        </v-progress-circular>
                        </div>
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-row>
                                <v-col cols="12" sm="4" md="2" offset-sm="6">
                                    <v-text-field v-model="modelProp" label="Orden de Compra" append-icon="mdi-magnify" @click:append="searchProposal" :rules="idRules"><v-icon slot="prepend" color="grey">mdi-format-list-bulleted</v-icon></v-text-field>
                                </v-col>
                                 <v-col cols="12" sm="4" md="3" offset-sm="1">
                                    <v-text-field v-model="modelOP" label="Punto" :disabled="true"><v-icon slot="prepend" color="grey">mdi-map-marker</v-icon></v-text-field>
                                </v-col>
                                 <!--<v-col cols="12" sm="4" md="4" offset-sm="1">
                                    <v-text-field v-model="modelOrig" label="Origen Propuesta" :disabled="true"><v-icon slot="prepend" color="grey">mdi-alpha-o-box</v-icon></v-text-field>
                                </v-col>-->
                                 <v-col cols="12" sm="4" md="8" offset-sm="5">
                                    <v-text-field v-model="modelSup" label="Folio" :disabled="true"><v-icon slot="prepend" color="grey">mdi-account</v-icon></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12"  sm="6" md="12" offset-sm="0">
                                </v-col>
                            </v-row>
                        </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="1" offset-sm="0">
                                    <v-subheader><h4>Asignacion</h4></v-subheader>
                                </v-col>
                                <v-col cols="12" sm="6" md="3" offset-sm="0">
                                    <v-text-field v-model="modelUnit" label="Unidad" :disabled="true"><v-icon slot="prepend" color="grey">mdi-alpha-u-box</v-icon></v-text-field>
                                </v-col>
                                 <v-col cols="12" sm="6" md="3" offset-sm="0">
                                    <v-text-field v-model="modelCant" label="Cantidad" :disabled="true"><v-icon slot="prepend" color="grey">mdi-alpha-c-box</v-icon></v-text-field>
                                </v-col>
                                 <!--<v-col cols="12" sm="6" md="3" offset-sm="0">
                                    <v-text-field v-model="modelRef" label="Referencias" :disabled="true"><v-icon slot="prepend" color="grey">mdi-alpha-r-box</v-icon></v-text-field>
                                </v-col>-->
                            </v-row>
                            
                             <v-row>
                                <v-col cols="12" sm="6" md="1" offset-sm="0">
                                    <v-subheader><h4>Nuevo Turno</h4></v-subheader>
                                </v-col>
                                <v-col cols="12" sm="6" md="3" offset-sm="0">
                                    <v-autocomplete
                                        v-model="modelStorage"
                                        :items="itemsStorage"
                                        color="black"
                                        hide-no-data
                                        hide-selected
                                        item-text="inputText"
                                        item-value="TurningStorageArea_id"
                                        label="Almacen"
                                        placeholder="Escribe para buscar"
                                        prepend-icon="mdi-alpha-t-box"   
                                        @change="getCapacity"
                                        return-object
                                    ></v-autocomplete>
                                </v-col>
                                 <v-col cols="12" sm="6" md="3" offset-sm="0">
                                    <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                    >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        readonly
                                        v-model="computedDateFormatted"
                                        clearable
                                        label="Fecha a Turnar"
                                        prepend-icon="mdi-alpha-f-box"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click:date="getCapacity"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker  v-model="date" @input="menu2 = false" :min="minDate" :max="maxDate" @change="getCapacity"></v-date-picker>
                                </v-menu>
                                </v-col>
                                 <v-col cols="12" sm="6" md="3" offset-sm="0">
                                    <v-autocomplete
                                        
                                        v-model="modelHour"
                                        :items="itemsHour"
                                        color="black"
                                        hide-no-data
                                        hide-selected
                                        item-text="inputText"
                                        item-value="CHour_id"
                                        label="Hora Turno"
                                        placeholder="Escribe para buscar"
                                        prepend-icon="mdi-alpha-t-box"
                                        @change="calcPctHour"   
                                        return-object
                                    ></v-autocomplete>
                                </v-col>
                                <!-- <v-col>
                                    <v-btn color="primary" text @click="getCapacity">Cargar</v-btn>
                                </v-col> -->
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="1" offset-sm="0">
                                    <v-subheader><h4>Tipificación</h4></v-subheader>
                                </v-col>
                                <v-col cols="12" sm="6" md="3" offset-sm="0">
                                    <v-select
                                    v-model="modelType"
                                    label="Tipificación"
                                    :items="turnTypes"
                                    required
                                    :rules="modelTypeRule"
                                    :error-messages="modelType === null ? ['La Tipificacion es requerida.'] : []"
                                    ><v-icon slot="prepend" color="black">mdi-alpha-t-box</v-icon></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="1" offset-sm="0">
                                    <v-subheader><h4>Comentario</h4></v-subheader>
                                </v-col>
                                <v-col cols="12" sm="6" md="9" offset-sm="0">
                                    <v-text-field v-model="modelCom" label="Comentario (para los proveedores que necesitan remanejo, indicar que tipo de remanejo y las cantidades)"><v-icon slot="prepend" color="black">mdi-alpha-c-box</v-icon></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="4" md="4" offset-sm="4">
                                    <v-card
                                    class="mx-auto text-center"
                                    color="primary"
                                    dark
                                    max-width="calc(80% - 32px)"
                                >
                                    <v-card-text>
                                    <v-sheet color="rgba(0, 0, 0, .12)">
                                        <v-sparkline
                                        :value="porcentaje"
                                        :labels="labels"
                                        color="rgba(255, 255, 255, .7)"
                                        height="100"
                                        padding="24"
                                        stroke-linecap="round"
                                        smooth
                                        >
                                        </v-sparkline>
                                    </v-sheet>
                                    </v-card-text>
                                    <v-divider></v-divider>

                                    <v-card-actions class="justify-center">
                                    <v-btn block text @click="openGrafico">
                                        CAPACIDAD POR HORA
                                    </v-btn>
                                    </v-card-actions>
                                </v-card>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-progress-linear :value="knowledge" height="25" :disabled="true" rounded>
                                        <strong>{{ knowledge }}%</strong>
                                    </v-progress-linear>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <div class="text-center">
                                        <v-btn color="primary" v-if="knowledge < 100" :disabled="turnbt || !modelTypeComplete" @click="turnar">Turnar</v-btn>
                                        <!-- <v-btn color="primary" v-if="knowledge < 100" :disabled="turnbt" @click="turnar">Turnar</v-btn> -->
                                    </div>
                                </v-col>
                               <!--  Se oculta boton Borrar Turno a pedido de Diego, ya que estan utilizando el borrado Masivo
                                <v-col>
                                    <div class="text-center">
                                        <v-btn color="primary" :disabled="active" @click.stop="dialog1=true" >Borrar Turno</v-btn>
                                    </div>
                                </v-col>
                                -->
                                <v-col>
                                    <div class="text-center">
                                        <v-btn color="primary" :disabled="active" @click.stop="dialog3=true" >Extensión</v-btn>
                                    </div>
                                </v-col>
                                <v-col>
                                    <div class="text-center">
                                        <v-btn color="primary" @click="limpiar_casos">Limpiar</v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                    </v-card-text>
                </v-card>
                <v-dialog v-model="dialog1" max-width="350">
                    <v-card color="blue-grey darken-3" dark>
                        <v-card-title class="headline"> ¿Desea borrar turno?</v-card-title>
                        <v-card-title>Recuerde que se cerrará la OC.</v-card-title>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn color="primary" @click="dialog1=false">Cancelar</v-btn>
                            <v-btn color="error" @click="borrar_turno()">Aceptar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialogAlert" width="auto">
                    <v-card color="blue-grey darken-3" dark>
                        <v-spacer></v-spacer>
                        <v-card-title class="pt-6">{{ msgGetExtention }}</v-card-title>
                        <v-spacer></v-spacer>
                        <v-card-title class="headline" style="color:rgb(251, 146, 146)">Recuerde: la extensión <span class="mx-1" style="text-decoration:underline; font-weight:bold;">NO</span> es una modificación del turno.</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary"
                                @click="dialogAlert = false"
                            >OK</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog3" max-width="450">
                    <v-card color="blue-grey darken-3" dark>
                        <v-card-title class="headline"> Seleccione la fecha a extender</v-card-title>
                     <v-col cols="12" sm="12">
                        <v-menu
                                    v-model="menu3"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="200px"
                                    >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        readonly
                                        v-model="computedDateFormatted2"
                                        clearable
                                        label="Fecha de Extension"
                                        prepend-icon="mdi-alpha-f-box"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click:date="getCapacity"
                                        width="20px"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker  v-model="maxDate7" @input="menu3 = false" :min="$store.state.propuesta.Closing_Dt" :max="fechamax" @change="getCapacity"></v-date-picker>
                                </v-menu>
                            </v-col>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn color="primary" @click="dialog3=false">Cancelar</v-btn>
                            <v-btn color="error" @click="extension_turno()">Aceptar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                </template>
                
                <template v-slot:item.Turn_Qty="props">
                        <v-edit-dialog
                        :return-value.sync="props.item.Turn_Qty"
                        @save="save(props.item.Turn_Qty)"
                        @cancel="cancel"
                        @open="open"
                        @close="close"
                        > {{ props.item.Turn_Qty }}
                        <template v-slot:input>
                            <v-text-field
                            v-model="props.item.Turn_Qty"
                            label="Edit"
                            single-line
                            counter
                            ></v-text-field>
                        </template>
                        </v-edit-dialog>
                    </template>
                </v-data-table>
            <!--</v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>-->
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import ProposalFilter from './ProposalFilter'
import Vue from 'vue'
import axios from 'axios'
const WARNING_THRESHOLD = 50;
const ALERT_THRESHOLD = 10;

const COLOR_CODES = {
  info: {
    color: "green"
  },
  warning: {
    color: "orange",
    threshold: WARNING_THRESHOLD
  },
  alert: {
    color: "red",
    threshold: ALERT_THRESHOLD
  }
};

export default {
 components: {
     apexchart: VueApexCharts,
     ProposalFilter
  },
  data: vm => ({
      dialogChart: false,
      timePassed: 0,
      timerInterval: null,
      fab: false,
      modelDate: null,
      modelHour: null,
      menu2: false,
      turnbt: false,
      timevalue:100,
      input_diable: false,
      modelProp: '',
      modelOP: null,
      modelSup: null,
      modelOrig: null,
      modelUnit: null,
      modelCant: null,
      modelRef: null,
      modelCom: null,
      modelType: null, 
      modelStorage: {},
      isLoading: false,
      searchStorage: null,
      ResultRows: [],
      ResultRowsHour: [],
      knowledge: 0,
      paso:0,
      capacityData: [],
      chart: false,
      labels: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24' ],
      porcentaje: [],
      //labels: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24' ],
      //values: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0 ],
      values: [],
      //filterProp: this.$store.state.propuesta,
      headers: [
      { text: 'Linea Propuesta ID', value: 'RequestProposalLine_id' },
      { text: 'SKU', value: 'Product_id' },
      { text: 'EAN', value: 'ProductBarCode_id' },
      { text: 'Cantidad Unid.', value: 'Request_Qty' },
      { text: 'Unidad Medida CD', value: 'MeasureUnit_id' },
      { text: 'PCB Cant', value: 'ProductPack_Qty' },
      { text: 'Propuesta Bultos', value: 'RequestPack_Qty' },
      { text: 'Propuesta Pallets', value: 'RequestPallet_Qty' },
      //{ text: 'Propuesta Cantidad', value: 'Turn_Qty' }
    ],
    users: [],
    idRules: [
      v => (v.length >= 8 && v.length < 9) || 'Se debe ingresar los últimos ocho dígitos de la OC'
    ],
    modelTypeRule: [
        v => !!v || 'La Tipificacion es requerida.'
        
    ],
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    config: {
        headers: {
            //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
            "api-user": sessionStorage.getItem('ApiUser_id')
        }
    },
    dialog: false,
    loaded: false,
    series: [],  
    chartOptions: {}  ,
    date: null,
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    currentDate: new Date().toISOString().substr(0, 10),
    minDate: null,
    maxDate: null,
    storage: null,
    overlay: false,
    overlayCapacity: false,
    active : true,
    dialog1: false,
    mensage : '',
    indicador : '',
    maxDate7: null,
    menu3: false,
    dialog3: false,
    Date7: null,
    fechamax: null,
    auxValidation: [],
    aux: '', 
    dialogAlert: false, 
    msgGetExtention: '',
    turnTypes: ['Problemas de transporte','Problemas de insumos' ,'Problemas de producción'  ,'Negociación de costos', 'Problemas en la recepción', 'Agrupación de órdenes de compra'] 
  }),
  created () {
    this.$store.commit('updateTitle', 'Cambio de Turno')
    document.addEventListener('beforeunload', this.handler)

    axios.post(this.api_tool_url + '/get_users', {ApiUser_id: sessionStorage.getItem('ApiUser_id')}, this.config)
        .then(response => {
            let user = response.data.ResultRows
            console.log(user)
            if(user.find(role => role.ApiUserType_id.trim() !== 'P')){
                this.modelType = 'Problemas de transporte'
            }
        })
        .catch(error => {
            alert(error.response.data.message)
        })
  },
  beforeDestroy() {
        axios.post(this.api_tool_url + '/del_reqproposalcurrselect', { RepSession_id: this.$store.state.ApiKey_id }, this.config)
        .then(response => {
            //alert("Se limpiaron los casos tomados")
            //this.$router.push("/" + this.$store.state.ApiKey_id + '/home')
        })
        .catch(error => {
            console.log(error)
            this.overlay = false
            //this.errorHandler(error)
        })
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    errorHandler(error) {
        if(error.response.data.message == 'Fuera de Horario para Turnar') {
            alert(error.response.data.message)
            this.$router.go("/")
        }
        else {
            //alert(error.response.data.message)
            //Se agrega esto ya que la linea de arriba siempre lanza el mensaje undefined
            //De esta forma sabremos el detalle del error
            let errorMessage = error.response && error.response.data && error.response.data.message 
                           ? error.response.data.message 
                           : error.toString();

            if (error.config && error.config.url) {
                errorMessage += ' (URL: ' + error.config.url + ')';
            }

            alert(errorMessage);
        }
    },
    handler: function handler(event) {
        axios.post(this.api_tool_url + '/del_reqproposalcurrselect', { RepSession_id: this.$store.state.ApiKey_id }, this.config)
        .then(response => {
            //alert("La sesion expiro, sera redireccionado")
            //this.$router.push("/" + this.$store.state.ApiKey_id + '/home')
        })
        .catch(error => {
            console.log(error)
            this.overlay = false
            //this.errorHandler(error)
        })
    },
       formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      searchProposal() {
        this.modelCant = 0
        this.modelRef = 0
        //this.modelProp = null
        this.modelOP = null
        this.modelSup = null
        this.modelOrig = null
        this.modelUnit =  null
        this.modelCom = null
        this.modelStorage = {}
        this.date = null
        this.minDate = null
        this.maxDate = null
        this.ResultRowsHour = []
        this.turnbt= true
        this.modelHour = null
        this.capacityData = []
        this.knowledge = 0
        this.porcentaje = []
        this.overlay = true
        let blockFilter = null
        blockFilter = {
            VendorPurchaseOrder_Num: this.modelProp,
            MotherSupplier_id: this.$store.state.ApiUser_Supplier
        }
        //console.log(blockFilter)
        axios.post(this.api_tool_url + '/check_blockedOC', blockFilter, this.config)
        .then(response => {
            //console.log(response.data)
            if(response.data.ResultRows.length !== 0) {
                this.overlay = false
                alert("No es posible modificar la fecha del turno de la OC.")
                return
            }else{
            
                if(this.modelProp == '') {
                    this.dialog = true
                    this.overlay = false
                } else {
                    this.overlay = true
                    let filter = null
                    let filter2 = null
                    filter2 = {ApiUser_id : this.$store.state.ApiUser_id, VendorPurchaseOrder_Num: this.modelProp}
                    axios.post(this.api_tool_url + '/get_ApiUserPurchaseOrder', filter2, this.config)
                    .then(response => {
                        if(response.data.ResultRows.length === 0) {
                            this.overlay = false
                            alert("Usuario no posee asignado el proveedor de la OC")
                        }
                        else{
                            this.$store.state.ApiUser_Supplier = response.data.ResultRows[0].MotherSupplier_id
                            
                            //if(this.$store.state.ApiUser_Supplier != '-1') {
                            filter = { 
                                filterCurrSelect: { RepSession_id: this.$store.state.ApiKey_id },
                                filterRequestProposal: { VendorPurchaseOrder_Num: this.modelProp, MotherSupplier_id: this.$store.state.ApiUser_Supplier }
                            }
                            // } else {
                            //     filter = { 
                            //         filterCurrSelect: { RepSession_id: this.$store.state.ApiKey_id },
                            //         filterRequestProposal: { VendorPurchaseOrder_Num: this.modelProp }
                            //     }
                            // }
                            
                            axios.post(this.api_tool_url + '/get_requestproposalline_order', filter, this.config)
                            .then(response => {
                                if(response.data == "No se encontro Orden") {
                                    this.overlay = false
                                    alert(response.data)
                                    return
                                }
                        
                                //console.log(response.data)
                                this.date = new Date()
                                this.date = this.date.toISOString().substr(0, 10)
                                if (response.data.RequestProposal[0]['Closing_Dt'] == this.date ){
                                    this.turnbt= true
                                }
                                else{
                                    this.turnbt= false
                                }

                                if(response.data.RequestProposal[0]['RequestProposalStatus_Cd'] == 'X') {
                                    this.overlay = false
                                    this.turnbt= true
                                    if (window.confirm('OC Cancelada. Reportar'))
                                    {this.$router.push("/" + this.$store.state.ApiKey_id + '/IncidentReport')} }
                                else if( response.data.RequestProposal[0]['RequestProposalStatus_Cd'] =='E') {
                                    this.overlay = false
                                    this.turnbt= true
                                    if (window.confirm('OC Eliminada. Reportar'))
                                    {this.$router.push("/" + this.$store.state.ApiKey_id + '/IncidentReport')} }
                                else if(response.data.RequestProposal[0]['RequestProposalStatus_Cd'] == 'F') {
                                    this.overlay = false
                                    this.turnbt= true
                                    if (window.confirm('OC Cerrada.')){
                                        // Agregado para dejar la pantalla vacía.
                                        this.modelCant = 0
                                        this.modelRef = 0
                                        //this.modelProp = null
                                        this.modelOP = null
                                        this.modelSup = null
                                        this.modelOrig = null
                                        this.modelUnit =  null
                                        this.modelCom = null
                                        this.modelType = null
                                        this.modelStorage = {}
                                        this.date = null
                                        this.minDate = null
                                        this.maxDate = null
                                        this.ResultRowsHour = []
                                        this.modelHour = null
                                        this.capacityData = []
                                        this.knowledge = 0
                                        this.porcentaje = []
                                    }
                                }
                                
                                else if(response.data.RequestProposal[0]['RequestProposalStatus_Cd'] == 'T') {
                                    this.overlay = false
                                    this.turnbt= true
                                    if (window.confirm('OC Totalmente Recepcionada.')){
                                        // Agregado para dejar la pantalla vacía.
                                        this.modelCant = 0
                                        this.modelRef = 0
                                        //this.modelProp = null
                                        this.modelOP = null
                                        this.modelSup = null
                                        this.modelOrig = null
                                        this.modelUnit =  null
                                        this.modelCom = null
                                        this.modelType = null
                                        this.modelStorage = {}
                                        this.date = null
                                        this.minDate = null
                                        this.maxDate = null
                                        this.ResultRowsHour = []
                                    }
                                }
                                    
                                    // Comentado para no redirigir
                                    // {this.$router.push("/" + this.$store.state.ApiKey_id + '/IncidentReport')} } 
                                else if (response.data.RequestProposal[0]['Closing_Dt'] < this.date ){
                                    this.overlay = false
                                    this.turnbt= true
                                    if (window.confirm('OC Cerrada.')){
                                        // Agregado para dejar la pantalla vacía.
                                        this.modelCant = 0
                                        this.modelRef = 0
                                        //this.modelProp = null
                                        this.modelOP = null
                                        this.modelSup = null
                                        this.modelOrig = null
                                        this.modelUnit =  null
                                        this.modelCom = null
                                        this.modelType = null
                                        this.modelStorage = {}
                                        this.date = null
                                        this.minDate = null
                                        this.maxDate = null
                                        this.ResultRowsHour = []
                                        this.modelHour = null
                                        this.capacityData = []
                                        this.knowledge = 0
                                        this.porcentaje = []
                                    }
                                }
                                    // Comentado para no redirigir
                                    // {this.$router.push("/" + this.$store.state.ApiKey_id + '/IncidentReport')}} 
                                else if(response.data.RequestProposal[0]['Turn_Ind'] == 'N'){
                                    this.overlay = false
                                    this.turnbt= true
                                    if (window.confirm('Sin turno asignado. Reportar'))
                                    {this.$router.push("/" + this.$store.state.ApiKey_id + '/IncidentReport')}} 
                                else{       
                                    //ACA EMPIEZA LA VALIDACION DEL UPDATE
                                    let rpID = {RequestProposal_id: response.data.RequestProposal[0]['RequestProposal_id']}
                                    axios.post(this.api_tool_url + '/get_requestproposalupdate', rpID, this.config)
                                    .then(response => {
                                        if(response.data.ResultRows == "No tiene actualizacion la orden") {
                                            this.overlay = false
                                            this.aux = ''}
                                            
                                        else{
                                            if (window.confirm('Se encuentra una modificacion ya realizada en el dia de hoy. ¿Desea continuar con el cambio?')){
                                                this.auxValidation = response.data.ResultRows
                                                this.aux = 'ok'
                                            }
                                            else{ this.$router.push("/" + this.$store.state.ApiKey_id + '/home')}
                                            }

                                    })
                                    .catch(error => {
                                        console.log(error)
                                        
                                    })
                                    //ACA EMPIEZA EL CAMBIO DE TURNO             
                                    this.users = response.data.RequestProposalLine
                                    //console.log(this.users[0])
                                    this.$store.commit('updateFilterDialog', response.data.RequestProposal[0])
                                    //console.log(this.$store.state.propuesta)
                                    this.modelCant = 0
                                    this.modelRef = 0
                                    this.modelProp = this.$store.state.propuesta.VendorPurchaseOrder_Num
                                    this.modelOP = this.$store.state.propuesta.OpPoint_id + ' - ' + this.$store.state.propuesta.OpPoint_Description
                                    this.modelSup = this.$store.state.propuesta.MotherSupplier_id + ' - ' + this.$store.state.propuesta.MotherSupplier_Desc
                                    this.modelOrig = this.$store.state.propuesta.RequestProposalSrc_id + ' - ' + this.$store.state.propuesta.RequestProposalSrc_Desc
                                    this.modelUnit =  this.$store.state.propuesta.ReceptionHandlingUnit_id + ' - ' + this.$store.state.propuesta.ReceptionHandlingUnit_Desc
                                    //console.log(this.$store.state.propuesta)
                                    this.modelStorage["TurningStorageArea_id"] = this.$store.state.propuesta.TurningStorageArea_id
                                    //console.log(this.storage)
                                    var tomorrow = new Date();
                                    tomorrow.setDate(tomorrow.getDate() + 1);
                                    this.date = new Date()
                                    this.date = tomorrow.toISOString().substr(0, 10)
                                    this.minDate = tomorrow.toISOString().substr(0, 10)
                                    this.maxDate = this.$store.state.propuesta.Closing_Dt
                                    this.getCapacity()
                                    this.active = false
                                    this.indicador = response.data.Turn_Ind[0]
                                    
                                    this.maxDate7 = new Date(response.data.RequestProposal[0]['Closing_Dt'] ).toISOString().substr(0, 10)

                                    //alert(this.maxDate7 + ' fecha de cierre')
                                    this.maxDate_7 = new Date(this.maxDate7)
                                    //alert(this.maxDate_7 + 'fecha de cierre con el new date')
                                    this.Date7 = this.maxDate_7.setDate(this.maxDate_7.getDate() + 3) 
                                    //alert(this.Date7 + 'fecha mas 7 dias')
                                    this.fechamax = new Date(this.Date7).toLocaleDateString('en-us', {year:'numeric', month: 'numeric', day: 'numeric'})
                                    this.fechamax = new Date(this.fechamax).toISOString().substr(0, 10) 
                                    

                                    this.users.forEach(function(entry) {
                                        if (this.$store.state.propuesta.ReceptionHandlingUnit_id == 'BU') {
                                            this.modelCant += entry.RequestPack_Qty;
                                        }else if (this.$store.state.propuesta.ReceptionHandlingUnit_id == 'PA') {
                                            this.modelCant += entry.RequestPallet_Qty;
                                        } else {
                                            this.modelCant += entry.Request_Qty;
                                        }

                                        ++this.modelRef;
                                    }, this);
                                    //this.startTimer();
                                    let filterStorage = { RequestProposal_id: this.$store.state.propuesta.RequestProposal_id, OpPoint_id: this.$store.state.propuesta.OpPoint_id }
                                    axios.post(this.api_tool_url + '/get_turningstoragearea', filterStorage, this.config)
                                    .then(response => {
                                        this.ResultRows = response.data.ResultRows
                                    })
                                    .catch(error => {
                                        console.log(error)
                                        this.errorHandler(error)
                                        //this.errorHandler(error)
                                    })

                                    let filterComentario = { RequestProposal_id: this.$store.state.propuesta.RequestProposal_id, OpPoint_id: this.$store.state.propuesta.OpPoint_id, VendorPurchaseOrder_Num: this.modelProp}
                                    axios.post(this.api_tool_url + '/get_comentario', filterComentario, this.config)
                                    .then(response => {
                                        if(response.data.ResultRows.length > 0){
                                            this.modelCom = response.data.ResultRows[0].Comment_Txt
                                        }else{
                                            this.modelCom = ''
                                        }
                                            
                                    })
                                    .catch(error => {
                                        console.log(error)
                                        this.errorHandler(error)
                                        //this.errorHandler(error)
                                    })

                                    let filterType = { RequestProposal_id: this.$store.state.propuesta.RequestProposal_id, OpPoint_id: this.$store.state.propuesta.OpPoint_id, VendorPurchaseOrder_Num: this.modelProp}
                                    axios.post(this.api_tool_url + '/get_turnType', filterType, this.config)
                                    .then(response => {
                                        if(response.data.ResultRows.length > 0){
                                            this.modelType = response.data.ResultRows[0].Type_Txt
                                        }
                                    })
                                    .catch(error => {
                                        console.log(error)
                                        this.errorHandler(error)
                                        //this.errorHandler(error)
                                    })

                                    let filterHour = { 
                                            CDay_id: this.date, 
                                            OpPoint_id: this.$store.state.propuesta.OpPoint_id,
                                            TurningStorageArea_id: this.$store.state.propuesta.TurningStorageArea_id                         
                                        }
                                    axios.post(this.api_tool_url + '/get_chour', filterHour, this.config)
                                    .then(response => {
                                        this.ResultRowsHour = response.data.ResultRows


                                        
                                        this.ResultRows.map(entry => {
                                        //console.log(entry)
                                        const inputText =  entry.TurningStorageArea_id + " - " + entry.TurningStorageArea_Desc
                                        if (entry.TurningStorageArea_id == this.$store.state.propuesta.TurningStorageArea_id) {
                                            Object.assign({}, entry, { inputText })
                                            this.modelStorage = entry
                                        }
                                        })
                                        this.overlay = false
                                    })
                                    .catch(error => {
                                        console.log(error)
                                        this.errorHandler(error)
                                        this.overlay = false
                                        //this.errorHandler(error)
                                    })
                                } 
                            })
                            .catch(error => {
                                console.log(error)
                                this.overlay = false;
                                this.errorHandler(error)
                                //this.errorHandler(error)
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.overlay = false;
                        this.errorHandler(error)
                                //this.errorHandler(error)
                    })
                }
            }
        }).catch(error => {
            console.log(error)
            this.errorHandler(error)
            this.overlay = false
        })
      },
      clear() {
          //console.log("Actualizacion")
          this.value = []
      },
      save(item) {
          //console.log(item)
      },
      open() {
          this.dialogChart = true
      },
      cancel() {

      },
      limpiar_casos() { 
        this.overlay = true 
        axios.post(this.api_tool_url + '/del_reqproposalcurrselect', { RepSession_id: this.$store.state.ApiKey_id }, this.config)
        .then(response => {
            //this.$router.push("/" + this.$store.state.ApiKey_id + '/home')
            this.modelCant = 0
            this.modelRef = 0
            //this.modelProp = null
            this.modelOP = null
            this.modelSup = null
            this.modelOrig = null
            this.modelUnit =  null
            this.modelStorage = {}
            this.date = null
            this.minDate = null
            this.maxDate = null
            this.modelCom = null
            this.modelType = null
            this.ResultRowsHour = []
            this.overlay = false
            this.active = true
            this.modelHour = null
            this.capacityData = []
            this.knowledge = 0
            this.porcentaje = []
            alert("Se limpiaron los casos tomados")
        })
        .catch(error => {
            console.log(error)
            this.overlay = false
            //this.errorHandler(error)
        })      

      },
    
      borrar_turno() { 
        this.overlay = true
        this.dialog1=false
        this.mensage = 'Borrando'
        
        let filterdel = {
                filterborrado : {RequestProposal_id: this.$store.state.propuesta.RequestProposal_id, VendorPurchaseOrder_Num: this.modelProp},
                ApiUser_EMail: this.$store.state.ApiUser_EMail,
                ApiUser_Id: this.$store.state.ApiUser_id
            }
        
        axios.post(this.api_tool_url + '/del_turno', filterdel , this.config)
        .then(response => {
            if (response.data.ResultRows.length === 0){
                this.overlay = false
                this.mensage = ''
			    alert("Se borro turno")
                this.limpiar_casos()
                this.users = []
                this.modelProp = ''}
		    else{
                this.overlay = false
                this.mensage = ''
			    alert("No se pudo borrar el turno")
                }
  
        })
        .catch(error => {
            console.log(error)
            this.overlay = false
            this.mensage = ''
        })      

      },
      extension_turno() { 
        this.overlay = true
        this.dialog3 = false
        this.mensage = 'Aguarde...'
        let op = this.$store.state.propuesta.OpPoint_id

        let filter = {
            RequestProposal_id: this.$store.state.propuesta.RequestProposal_id,
            VendorPurchaseOrder_Num: this.modelProp,
            Closing_Dt : this.computedDateFormatted2,
            ApiUser_Id: this.$store.state.ApiUser_id,
            ApiUser_EMail: this.$store.state.ApiUser_EMail
        }
        
        if (op == '10924' || op == '10951' || op == '10958') {
            this.overlay = false
            this.mensage = ''
            alert("No se puede extender la OC - Reportar")
        } else {
                // Valida que no se haya extendido previamente
            axios.post(this.api_tool_url + '/get_checkExtention', filter, this.config)
            .then(checkResponse => {
                if (checkResponse.data.Result === "OK") {
                    axios.post(this.api_tool_url + '/get_extention', filter, this.config)
                    .then(response => {
                        if (response.data.ResultRows) {
                            this.mensage = ''
                            this.limpiar_casos()
                            this.users = []
                            this.modelProp = ''
                            // alert(response.data.ResultRows)
                            this.msgGetExtention = response.data.ResultRows
                            this.dialogAlert = true
                        }
                        this.overlay = false
                    })
                    .catch(error => {
                        console.error(error)
                        this.overlay = false
                        this.mensage = ''
                    })
                } else {
                    this.overlay = false
                    this.mensage = ''
                    alert("La OC fue extendida anteriormente, sólo se permite una única extensión")
                }
            })
            .catch(error => {
                console.error(error)
                this.overlay = false
                this.mensage = ''
            })
        }    
    }
    ,
      
      chour_change()
      {
          let filterHour = { 
                        CDay_id: this.date, 
                        OpPoint_id: this.$store.state.propuesta.OpPoint_id,
                        TurningStorageArea_id: this.$store.state.propuesta.TurningStorageArea_id                         
                    }
                axios.post(this.api_tool_url + '/get_chour', filterHour, this.config)
                .then(response => {
                    this.ResultRowsHour = response.data.ResultRows


                    
                    this.ResultRows.map(entry => {
                    console.log(entry)
                    const inputText = entry.TurningStorageArea_id + " - " + entry.TurningStorageArea_Desc
                    if (entry.TurningStorageArea_id == this.$store.state.propuesta.TurningStorageArea_id) {
                        Object.assign({}, entry, { inputText })
                        this.modelStorage = entry
                    }
                    })
                    this.overlay = false
                })
                .catch(error => {
                    console.log(error)
                    this.errorHandler(error)
                    this.overlay = false
                    //this.errorHandler(error)
                })
      },
      close() {
          console.log(this.$store.state.closeInd)
        if(this.$store.state.closeInd == "C") {
            this.dialog = false
            return
        }
        if(this.$store.state.propuesta == undefined) {
            alert("Debe elegir una orden de compra")
            return
        }
        this.dialog = false
        this.overlay = true
        this.timePassed = 0
        //console.log(this.$store.state.propuesta)
        let filter = { 
                filterCurrSelect: { RequestProposal_id: this.$store.state.propuesta.RequestProposal_id, RepSession_id: this.$store.state.ApiKey_id },
                filterRequestProposal: { RequestProposal_id: this.$store.state.propuesta.RequestProposal_id }
            }
        axios.post(this.api_tool_url + '/get_requestproposalline', filter, this.config)
            .then(response => {
                this.users = response.data.ResultRows
                //console.log(this.$store.state.propuesta)
                this.modelCant = 0
                this.modelRef = 0
                this.modelProp = this.$store.state.propuesta.VendorPurchaseOrder_Num
                this.modelOP = this.$store.state.propuesta.OpPoint_id + ' - ' + this.$store.state.propuesta.OpPoint_Description
                this.modelSup = this.$store.state.propuesta.MotherSupplier_id + ' - ' + this.$store.state.propuesta.MotherSupplier_Desc
                this.modelOrig = this.$store.state.propuesta.RequestProposalSrc_id + ' - ' + this.$store.state.propuesta.RequestProposalSrc_Desc
                this.modelUnit =  this.$store.state.propuesta.ReceptionHandlingUnit_id + ' - ' + this.$store.state.propuesta.ReceptionHandlingUnit_Desc
                //console.log(this.$store.state.propuesta)
                this.modelStorage["TurningStorageArea_id"] = this.$store.state.propuesta.TurningStorageArea_id
                //console.log(this.storage)
                var tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                this.date = new Date()
                this.date = tomorrow.toISOString().substr(0, 10)
                this.minDate = tomorrow.toISOString().substr(0, 10)
                this.maxDate = this.$store.state.propuesta.Closing_Dt
                this.getCapacity()

                this.users.forEach(function(entry) {
                    if (this.$store.state.propuesta.ReceptionHandlingUnit_id == 'BU') {
                        this.modelCant += entry.RequestPack_Qty;
                    }else if (this.$store.state.propuesta.ReceptionHandlingUnit_id == 'PA') {
                        this.modelCant += entry.RequestPallet_Qty;
                    } else {
                        this.modelCant += entry.Request_Qty;
                    }

                    ++this.modelRef;
                }, this);
                //this.startTimer();
                let filterStorage = { RequestProposal_id: this.$store.state.propuesta.RequestProposal_id, OpPoint_id: this.$store.state.propuesta.OpPoint_id }
                axios.post(this.api_tool_url + '/get_turningstoragearea', filterStorage, this.config)
                .then(response => {
                    this.ResultRows = response.data.ResultRows
                })
                .catch(error => {
                    console.log(error)
                    this.errorHandler(error)
                    //this.errorHandler(error)
                })

                let filterComentario = { RequestProposal_id: this.$store.state.propuesta.RequestProposal_id, OpPoint_id: this.$store.state.propuesta.OpPoint_id, VendorPurchaseOrder_Num: this.modelOP}
                axios.post(this.api_tool_url + '/get_comentario', filterComentario, this.config)
                .then(response => {
                    this.modelCom = response.data.ResultRows[0].Comment_Txt
                })
                .catch(error => {
                    console.log(error)
                    this.errorHandler(error)
                    //this.errorHandler(error)
                })

                let filterType = { RequestProposal_id: this.$store.state.propuesta.RequestProposal_id, OpPoint_id: this.$store.state.propuesta.OpPoint_id, VendorPurchaseOrder_Num: this.modelOP}
                axios.post(this.api_tool_url + '/get_turnType', filterType, this.config)
                .then(response => {
                    this.modelType = response.data.ResultRows[0].Type_Txt
                })
                .catch(error => {
                    console.log(error)
                    this.errorHandler(error)
                    //this.errorHandler(error)
                })

                let filterHour = { 
                        //MotherSupplier_id: this.$store.state.propuesta.MotherSupplier_id, 
                        OpPoint_id: this.$store.state.propuesta.OpPoint_id,
                        CDay_id: this.date
                    }
                axios.post(this.api_tool_url + '/get_chour', filterHour, this.config)
                .then(response => {
                    this.ResultRowsHour = response.data.ResultRows


                    
                    this.ResultRows.map(entry => {
                    console.log(entry)
                    const inputText =  entry.TurningStorageArea_id + " - " + entry.TurningStorageArea_Desc
                    if (entry.TurningStorageArea_id == this.$store.state.propuesta.TurningStorageArea_id) {
                        Object.assign({}, entry, { inputText })
                        this.modelStorage = entry
                    }
                    })
                    this.overlay = false
                })
                .catch(error => {
                    console.log(error)
                    this.errorHandler(error)
                    this.overlay = false
                    //this.errorHandler(error)
                })
            })
            .catch(error => {
                console.log(error)
                this.errorHandler(error)
                this.overlay = false
                //this.errorHandler(error)
            })
      },
      getCapacity() {
            if(this.overlay == false){
                this.overlayCapacity = true
            }
            // Al cambiar fecha o almacén el porcentaje y la hora elegidos dejan de ser válidos
            this.capacityData = []
            this.knowledge = 0
            this.modelHour = null
            // Solo vale la última consulta: si llegan respuestas fuera de orden se descartan las viejas
            this.capReqSeq = (this.capReqSeq || 0) + 1
            const capReqSeq = this.capReqSeq

            let filterCapacity = { 
                OpPoint_id: this.$store.state.propuesta.OpPoint_id, 
                TurningStorageArea_id: this.modelStorage.TurningStorageArea_id,
                CDay_id: this.date,
                //CHour_id: this.modelHour.CHour_id
            }
            this.series = []
            //console.log(filterCapacity)
            axios.post(this.api_tool_url + '/get_effectiveturncapacity', filterCapacity, this.config)
            .then(response => {
                if (capReqSeq !== this.capReqSeq) { return }
                let nominal = []
                let tolerada = []
                let ocupada = []
                let porcentaje = []
                let Dispo = []
                let cant = 0;
                //this.ResultRows = response.data.ResultRows
                response.data.ResultRows.forEach(function(entry) {
                    //console.log(entry)
                    this.capacityData.push(Object.assign({}, entry))
                    nominal.push(entry.HandlingCapacity_Cnt)
                    tolerada.push(entry.ToleratedHandlingCapacity_Cnt)
                    ocupada.push(entry.OccupiedHandlingCapacity_Cnt)
                    cant = entry.ToleratedHandlingCapacity_Cnt - entry.OccupiedHandlingCapacity_Cnt
                    if(cant<0)
                    {
                        cant = 0
                    }

                    Dispo.push(parseInt(cant))
                    if(entry.OccupiedHandlingCapacity_Cnt == 0 || entry.ToleratedHandlingCapacity_Cnt == 0) {
                        porcentaje.push(0)
                    } else {
                        porcentaje.push(parseInt((entry.OccupiedHandlingCapacity_Cnt * 100) / entry.ToleratedHandlingCapacity_Cnt))
                    }
                }, this)
                //console.log(nominal)
                //console.log(tolerada)
                //console.log(ocupada)
                //console.log(porcentaje)
                //porcentaje = [0,90,0,80,0,0,0,50,0,0,0,0,20,0,0,0,0,0,0,0,0,0,0,0]
                //console.log(this.$store.state)
                //console.log(this.$store.state.ApiUserType_id)
                if(this.$store.state.ApiUserType_id == 'R ') {
                    this.series = [//{
                    //      name: 'Cantidad Nominal',
                    //      type: 'column',
                    //      data: nominal
                    // },{
                    //     name: 'Cantidad Tolearada',
                    //     type: 'column',
                    //     data: tolerada
                    // },{
                    //     name: 'Cantidad Ocupada',
                    //     type: 'line',
                    //     color: 'black',
                    //     data: ocupada
                    // },
                    {
                        name: 'Cantidad de Bultos Disponible',
                        type: 'column',
                        color: 'black',
                        data: Dispo
                    }]

                    this.chartOptions = {
                        chart: {
                        height: 350,
                        type: 'line',
                        },
                        stroke: {
                        width: [0, 4]
                        },
                        title: {
                        text: 'Cantidad por Hora'
                        },
                        dataLabels: {
                        enabled: true,
                        enabledOnSeries: [1]
                        },
                        labels: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24' ],
                        xaxis: {
                        type: 'string'
                        }
                    }
                } else {
                    this.series = [{
                        name: 'Porcentaje Ocupado',
                        type: 'column',
                        data: porcentaje
                    }]

                    this.chartOptions = {
                        chart: {
                        height: 350,
                        type: 'line',
                        },
                        stroke: {
                        width: [0, 4]
                        },
                        title: {
                        text: 'Cantidad Disponible'
                        },
                        dataLabels: {
                        enabled: true,
                        enabledOnSeries: [1]
                        },
                        labels: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24' ],
                        xaxis: {
                        type: 'string'
                        }
                    }
                }
                this.porcentaje = porcentaje
                this.overlayCapacity = false
                // Si el usuario ya eligió una hora mientras cargaba la capacidad, se recalcula
                if (this.modelHour) { this.calcPctHour() }
                //this.dialogChart = true
            })
            .catch(error => {
                console.log(error)
                this.overlayCapacity = false
                this.errorHandler(error)
                //this.errorHandler(error)
            })

            let filterHour = { 
                        CDay_id: this.date, 
                        OpPoint_id: this.$store.state.propuesta.OpPoint_id,
                        TurningStorageArea_id: this.$store.state.propuesta.TurningStorageArea_id                         
                    }
                axios.post(this.api_tool_url + '/get_chour', filterHour, this.config)
                .then(response => {
                    this.ResultRowsHour = response.data.ResultRows


                    
                    this.ResultRows.map(entry => {
                    //console.log(entry)
                    const inputText = entry.TurningStorageArea_id + " - " + entry.TurningStorageArea_Desc
                    if (entry.TurningStorageArea_id == this.$store.state.propuesta.TurningStorageArea_id) {
                        Object.assign({}, entry, { inputText })
                        this.modelStorage = entry
                    }
                    })
                    this.overlay = false
                })
                .catch(error => {
                    console.log(error)
                    this.errorHandler(error)
                    this.overlay = false
                    //this.errorHandler(error)
                })
      },
      openGrafico() {
          this.dialogChart = true
      },
      onTimesUp() {
        clearInterval(this.timerInterval);
    },

     startTimer() {
       this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
     },
     calcPctHour(){

        if (!this.modelHour) {
            this.knowledge = 0
            return
        }
        // Sin fila de capacidad para la hora (o capacidad 0) => 100%: no se puede turnar
        this.knowledge = 100
        const entry = this.capacityData.find(e => e.CHour_id == this.modelHour.CHour_id)
        if (entry && entry.ToleratedHandlingCapacity_Cnt) {
            this.knowledge = parseFloat(((entry.OccupiedHandlingCapacity_Cnt + this.modelCant) * 100) / entry.ToleratedHandlingCapacity_Cnt).toFixed(2)
        }

        //  this.capacityData.map(entry => {
        //      if(entry.CHour_id == this.modelHour.CHour_id) {
        //         if(entry.ToleratedHandlingCapacity_Cnt) {
        //              console.log(entry)
        //              this.knowledge = parseFloat(((entry.OccupiedHandlingCapacity_Cnt + this.modelCant) * 100) / entry.ToleratedHandlingCapacity_Cnt).toFixed(2)
        //          } else {
        //              this.knowledge = 100
        //          }
        //      }
        // })
     },
     addZero(i) {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    },
    turnar() {
        console.log("Boton de Turnado")
        this.overlay = true
        //if(this.knowledge > 0 && this.knowledge < 100) {
        let capacidadOk = this.knowledge > 0 && this.knowledge < 100
        if (!capacidadOk && this.modelHour && this.date) {
            // Usuarios de reposición pueden turnar por excepción, con confirmación explícita.
            // El servidor vuelve a validar el tipo de usuario.
            if (window.confirm('El horario no tiene capacidad disponible. Â¿Confirma el turno por excepciÃ³n?')) {
                capacidadOk = true
            } else {
                this.overlay = false
                return
            }
        }
         if(capacidadOk) {
            console.log("Puede turnar")
            console.log("Llego a 0")
            var date = new Date()
            var h = this.addZero(date.getHours());
            var m = this.addZero(date.getMinutes());
            var s = this.addZero(date.getSeconds());

            var RequestProposalTurnLine = []
            var RequestProposalTurnLineOp = []

            if(this.date > this.$store.state.propuesta.Closing_Dt)
            {
                this.turnbt= true
                if (window.confirm('Fecha de Turno mayor a fecha de cierre. Reportar'))
                {this.$router.push("/" + this.$store.state.ApiKey_id + '/IncidentReport')} 
                this.overlay = false
            }
            else {
                this.users.forEach(function(entry) {
                if (this.$store.state.propuesta.ReceptionHandlingUnit_id == 'BU') {
                        var cant = entry.RequestPack_Qty;
                    }else if (this.$store.state.propuesta.ReceptionHandlingUnit_id == 'PA') {
                        var cant =  entry.RequestPallet_Qty;
                    } else {
                        var cant = entry.Request_Qty;
                    }
                var line = {
                    RequestProposal_id: this.$store.state.propuesta.RequestProposal_id,
                    RequestProposalLine_id: entry.RequestProposalLine_id,
                    OpPoint_id: this.$store.state.propuesta.OpPoint_id,
                    TurningStorageArea_id: this.modelStorage.TurningStorageArea_id,
                    CDay_id: this.date,
                    CHour_id: this.modelHour.CHour_id,
                    HandlingUnit_id: this.$store.state.propuesta.ReceptionHandlingUnit_id,
                    Turn_Qty: cant,
                    RepEvent_id: this.$store.state.ApiKey_id,
                    LastOpRepUser_id: this.$store.state.ApiUser_id,
                    RepEvent_Dt: this.currentDate,
                    RepEvent_Tm: h + ":" + m + ":" + s,
                }

                var lineOp = {
                    RequestProposal_id: this.$store.state.propuesta.RequestProposal_id,
                    RequestProposalLine_id: entry.RequestProposalLine_id,
                    OpPoint_id: this.$store.state.propuesta.OpPoint_id,
                    TurningStorageArea_id: this.modelStorage.TurningStorageArea_id,
                    CDay_id: this.date,
                    CHour_id: this.modelHour.CHour_id,
                    RequestProposalTurnLineOp_Dttm: this.currentDate + " " + h + ":" + m + ":" + s,
                    RequestProposalTurnOpType_id: 'TM',
                    HandlingUnit_id: this.$store.state.propuesta.ReceptionHandlingUnit_id,
                    Turn_Qty: cant,
                    RepEvent_id: this.$store.state.ApiKey_id,
                    LastOpRepUser_id: this.$store.state.ApiUser_id,
                    RepEvent_Dt: this.currentDate,
                    RepEvent_Tm: h + ":" + m + ":" + s,
                }
                RequestProposalTurnLine.push(Object.assign({}, line))
                RequestProposalTurnLineOp.push(Object.assign({}, lineOp))
            }, this);
            
            let filter = { 
                //RequestProposal_id: this.$store.state.propuesta.RequestProposal_id,
                RequestProposalTurn: {
                    RequestProposal_id: this.$store.state.propuesta.RequestProposal_id,
                    OpPoint_id: this.$store.state.propuesta.OpPoint_id,
                    TurningStorageArea_id: this.modelStorage.TurningStorageArea_id,
                    CDay_id: this.date,
                    CHour_id: this.modelHour.CHour_id,
                    TurnAssignmentType_id: 'MANUAL',
                    HandlingUnit_id: this.$store.state.propuesta.ReceptionHandlingUnit_id,
                    Turn_Qty: this.modelCant,
                    TurnSrcSupplier_id: this.$store.state.propuesta.MotherSupplier_id,
                    RepEvent_id: this.$store.state.ApiKey_id,
                    LastOpRepUser_id: this.$store.state.ApiUser_id,
                    RepEvent_Dt: this.currentDate,
                    RepEvent_Tm: h + ":" + m + ":" + s,
                },
                RequestProposalTurnLine: RequestProposalTurnLine,
                RequestProposalTurnLineOp: RequestProposalTurnLineOp,
                RequestProposalComment: {
                    RequestProposal_id: this.$store.state.propuesta.RequestProposal_id,
                    OpPoint_id: this.$store.state.propuesta.OpPoint_id,
                    VendorPurchaseOrder_Num: this.modelProp,
                    Comment_Txt: this.modelCom,
                    RepEvent_id: this.$store.state.ApiKey_id,
                    LastOpRepUser_id: this.$store.state.ApiUser_id,
                    RepEvent_Dt: this.currentDate,
                    RepEvent_Tm: h + ":" + m + ":" + s,
                },
                RequestProposalType: {
                    RequestProposal_id: this.$store.state.propuesta.RequestProposal_id,
                    OpPoint_id: this.$store.state.propuesta.OpPoint_id,
                    VendorPurchaseOrder_Num: this.modelProp,
                    Type_Txt: this.modelType,
                    RepEvent_id: this.$store.state.ApiKey_id,
                    LastOpRepUser_id: this.$store.state.ApiUser_id,
                    RepEvent_Dt: this.currentDate,
                    RepEvent_Tm: h + ":" + m + ":" + s,
                },
                ApiUser_EMail: this.$store.state.ApiUser_EMail,
                RequestProposalValidation: {
                    auxValidation :this.auxValidation,
                    aux: this.aux
                }
            }
            axios.post(this.api_tool_url + '/createTurn', filter, this.config)
            .then(response => {
                console.log(response)
                this.overlay = false
                // Se cambia para que traiga el mensaje del metodo
                alert(response.data.message)
                //alert("Turnado Realizado con exito")
                this.modelCant = 0
                this.modelRef = 0
                //this.modelProp = null
                this.modelOP = null
                this.modelSup = null
                this.modelOrig = null
                this.modelUnit =  null
                this.modelCom = null
                this.modelType = null
                this.modelStorage = {}
                this.date = null
                this.minDate = null
                this.maxDate = null
                this.ResultRowsHour = []
                this.active = true
                this.users = []
            })
            .catch(error => {
                console.log(error)
                if (error.response && error.response.data && error.response.data.message) {
                    alert(error.response.data.message)
                }
                this.overlay = false
                //this.errorHandler(error)
                //this.errorHandler(error)
            })
            }

            
         }
         else {
             this.overlay = false
             console.log("No puede turnar")
             alert("Fecha y hora con capacidad excedida, porfavor seleccionar otro horario o fecha")
             //this.errorHandler(error)
         }
     }
  },
  computed: {

      itemsStorage () {
        return this.ResultRows.map(entry => {
        //   const Description = entry.Description.length > this.descriptionLimit
        //     ? entry.Description.slice(0, this.descriptionLimit) + '...'
        //     : entry.Description

        //   return Object.assign({}, entry, { Description })
        const inputText = entry.TurningStorageArea_id + " - " + entry.TurningStorageArea_Desc
        //console.log(inputText)
        return Object.assign({}, entry, { inputText })
        //return entry
        })
      },
      itemsHour () {
        return this.ResultRowsHour.map(entry => {
        //   const Description = entry.Description.length > this.descriptionLimit
        //     ? entry.Description.slice(0, this.descriptionLimit) + '...'
        //     : entry.Description

        //   return Object.assign({}, entry, { Description })
        const inputText = entry.CHour_Description //entry.CHour_id + " - " + entry.CHour_Description
        //console.log(inputText)
        return Object.assign({}, entry, { inputText })
        //return entry
        })
      },
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
      computedDateFormatted2 () {
        return this.formatDate(this.maxDate7)
      },
      circleDasharray() {
      return `${(this.timeFraction * this.$store.state.tiemout).toFixed(0)} 283`;
    },

    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      const minutes = Math.floor(timeLeft / 60);
      let seconds = timeLeft % 60;

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      //console.log(this.timeLeft)
      if(this.timeLeft == 0) {
           console.log("Llego a 0")
            let filter = { 
                //RequestProposal_id: this.$store.state.propuesta.RequestProposal_id,
                RepSession_id: this.$store.state.ApiKey_id
            }

            axios.post(this.api_tool_url + '/del_reqproposalcurrselect', filter, this.config)
            .then(response => {
                alert("La sesion expiro, sera redireccionado")
                 this.$router.push("/" + this.$store.state.ApiKey_id + '/home')
            })
            .catch(error => {
                console.log(error)
                this.overlay = false
                //this.errorHandler(error)
                //this.errorHandler(error)
            })
      }

      return `${minutes}:${seconds}`;
    },

    timeLeft() {
        this.timevalue=this.timevalue-((100/this.$store.state.tiemout))
      return this.$store.state.tiemout - this.timePassed;
    },

    timeFraction() {
      const rawTimeFraction = this.timeLeft / this.$store.state.tiemout;
      return rawTimeFraction - (1 / this.$store.state.tiemout) * (1 - rawTimeFraction);
    },

    remainingPathColor() {
      const { alert, warning, info } = COLOR_CODES;
      if (this.timeLeft <= alert.threshold) {
        return alert.color;
      } else if (this.timeLeft <= warning.threshold) {
        return warning.color;
      } else {
        return info.color;
      }
    },

    modelTypeComplete() {
        return this.modelType !== null && this.modelType !== ''
    }
  },
  watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
      timeLeft(newValue) {
        if (newValue === 0) {
            this.onTimesUp();
        }
      }
  }
}
</script>
<style>
  /* This is for documentation purposes and will not be needed in your application */
  #lateral .v-btn--example {
    bottom: 0;
    position: absolute;
    margin: 0 0 16px 16px;
  }
</style>


// WEBPACK FOOTER //
// src/components/RequestProposalGrid.vue